import React from 'react';
import styled from 'styled-components';

import Source from 'shared/components/Source';

import { SourceNameCellProps } from './types';

const StyledContainer = styled.div``;

const SourceNameCell = ({
  value: source,
}: SourceNameCellProps) => (
  <StyledContainer>
    <Source source={source} />
  </StyledContainer>
);

export default SourceNameCell;
